<ng-container *transloco="let t;">
    <form [formGroup]="formGroup">
        @for(field of group.fields; track field; let idx = $index){
            @if(field.type === 'default') {
                <div class="mb-50" [ngClass]="{'position-relative': field.field_name === 'signing_reminder'}">
                    <app-dynamic-field
                        [field]="field"
                        [shouldShowDueDateField]="shouldShowDueDateField"
                        [formGroup]="formGroup"
                        [documentData]="documentData"
                        [isDueDateDisabled]="isDueDateDisabled"
                        [disableFlatpickr]="disableFlatpickr"
                        [tags]="tags"
                        [sectionName]="sectionName"
                        [hasFullAccess]="hasFullAccessToDocument"
                        [canEdit]="canEditDocument"
                        (fieldAction)="handleFieldAction($event)">
                    </app-dynamic-field>
                </div>
            }
        }
    </form>
</ng-container>